import { render, staticRenderFns } from "./ModuleLead.vue?vue&type=template&id=5fc15158&scoped=true&"
import script from "./ModuleLead.vue?vue&type=script&lang=js&"
export * from "./ModuleLead.vue?vue&type=script&lang=js&"
import style0 from "./ModuleLead.vue?vue&type=style&index=0&id=5fc15158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc15158",
  null
  
)

export default component.exports